import React from 'react';
import { Grid, Typography, Tabs, Tab } from '@mui/material';
import Chip from 'ui-component/extended/Chip';
import { IconFriends } from '@tabler/icons';
import { TAB_SCHEDULE } from './groupTabs';
import { Link } from 'react-router-dom';

const GroupHeader = ({ groupInfo, sortedTabOptions, groupTab, handleChange, isGroupRoute, baseRoute, a11yProps, theme }) => (
    <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h2" ml={2}>
                        {groupInfo?.group.name}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            justifyContent: 'flex-end',
                            [theme.breakpoints.down('lg')]: {
                                justifyContent: 'center'
                            }
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center" ml={2}>
                <Grid item>
                    <Typography variant="caption"> {groupInfo?.facility?.name}</Typography>
                </Grid>
                <Grid container justifyContent="flex-start">
                    {!groupInfo?.group?.club || groupInfo.group?.club?.visibility === 'public' || groupInfo?.group?.club?.is_member ? (
                        <Tabs
                            value={groupTab}
                            variant="scrollable"
                            onChange={handleChange}
                            sx={{
                                marginTop: 2.5,
                                '& .MuiTabs-flexContainer': {
                                    border: 'none'
                                },
                                '& a': {
                                    minHeight: 'auto',
                                    minWidth: 10,
                                    py: 1.5,
                                    px: 1,
                                    mr: 2.25,
                                    color: 'grey.700',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                '& a.Mui-selected': {
                                    color: 'primary.main'
                                },
                                '& a > svg': {
                                    marginBottom: '4px !important',
                                    mr: 1.25
                                }
                            }}
                        >
                            {sortedTabOptions.map((option, index) => (
                                <Tab
                                    key={index}
                                    component={Link}
                                    to={option.to}
                                    icon={option.icon}
                                    label={option.label}
                                    value={option.id}
                                    {...a11yProps(index)}
                                />
                            ))}
                        </Tabs>
                    ) : (
                        <Tabs value={TAB_SCHEDULE} variant="scrollable" sx={{ marginTop: 2.5 }}>
                            <Tab
                                component={Link}
                                to={`${baseRoute}/memberships`}
                                icon={<IconFriends stroke={1.5} size="17px" />}
                                label="Memberships"
                                value={TAB_SCHEDULE}
                                {...a11yProps(0)}
                            />
                        </Tabs>
                    )}
                </Grid>
            </Grid>
        </Grid>
    </Grid>
);

export default GroupHeader;
